


























import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class LinkIcon extends Vue {
  @Prop() public to: string
  @Prop({ required: true }) public name: string

  /**
   * New path.
   */
  get newPath() {
    return this.to
      ? `/${this.$route.params.project}${this.to}`.replace(/\/$/, '')
      : null
  }
}
